const SectionDoa = () => {
  return (
    <>
      <div className="overflow-x-hidden pt-10">
        <h2 className="text-center font-Amiri text-xl leading-10" data-aos="zoom-in" data-aos-duration="1000">
          وَمِنْ اٰيٰتِهٖٓ اَنْ خَلَقَ لَكُمْ مِّنْ اَنْفُسِكُمْ اَزْوَاجًا لِّتَسْكُنُوْٓا اِلَيْهَا وَجَعَلَ بَيْنَكُمْ مَّوَدَّةً وَّرَحْمَةً ۗاِنَّ فِيْ ذٰلِكَ لَاٰيٰتٍ لِّقَوْمٍ يَّتَفَكَّرُوْنَ
        </h2>
        <p className="my-10 text-center italic" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="300">
          " Dan di antara tanda-tanda kekuasaan-Nya diciptakan-Nya untukmu pasangan hidup dari jenismu sendiri supaya kamu dapat ketenangan hati dan dijadikannya kasih sayang di antara kamu. Sesungguhnya yang demikian menjadi tanda-tanda kebesaran-Nya bagi orang-orang yang berpikir. "
        </p>
        <p className="text-center italic" data-aos="fade-right" data-aos-duration="1000" data-aos-delay="600">
          ( Q.S. Ar-Rum: 21 )
        </p>
      </div>
    </>
  );
};

export default SectionDoa;
